import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

// Pages
const DashboardPage = lazy(() => import('../../pages/DashboardPage'))
const AccountPage = lazy(() => import('../../pages/AccountPage'))
const WorkingHoursPage = lazy(() => import('../../pages/WorkingHoursPage'))
const FeedbackPage = lazy(() => import('../../pages/FeedbackPage'))
const TeamPage = lazy(() => import('../../pages/TeamPage'))
const ClientsPage = lazy(() => import('../../pages/ClientsPage'))
const ServicesPage = lazy(() => import('../../pages/ServicesPage'))
// Feature Views
const ServicesAddView = lazy(
  () => import('../../features/services/ui/ServicesAddView'),
)
const ClientsAddView = lazy(
  () => import('../../features/clients/ui/ClientsAddView'),
)
const BookingsView = lazy(
  () => import('../../features/bookings/ui/BookingsView'),
)
const BookingAddView = lazy(
  () => import('../../features/bookings/ui/BookingAddView'),
)

export const getOwnerRoutes = () => [
  {
    path: 'dashboard',
    element: <DashboardPage />,
  },
  {
    path: 'account',
    element: <AccountPage />,
  },
  {
    path: 'team',
    element: <TeamPage />,
  },
  {
    path: 'services',
    children: [
      { element: <ServicesPage />, index: true },
      { path: 'add', element: <ServicesAddView /> }, // For creating a new service
      { path: 'edit/:serviceId', element: <ServicesAddView /> }, // For editing an existing service
    ],
  },
  { path: 'workinghours', element: <WorkingHoursPage /> },
  {
    path: 'clients',
    children: [
      { element: <ClientsPage />, index: true },
      { path: 'add', element: <ClientsAddView /> }, // For creating a new client
      { path: 'edit/:clientId', element: <ClientsAddView /> }, // For editing an existing client
    ],
  },
  {
    path: 'bookings',
    children: [
      { element: <BookingsView />, index: true },
      { path: 'add', element: <BookingAddView /> },
      { path: 'edit/:bookingId', element: <BookingAddView /> },
    ],
  },
  {
    path: 'feedback',
    element: <FeedbackPage />,
  },
  // Перенаправляем с корневого пути на дашборд
  { path: '/', element: <Navigate to="/dashboard" replace /> },
]
